var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(false)?_c('van-tabs',{attrs:{"type":"card"}},[_c('van-tab',{attrs:{"title":"全部","name":"0"}}),_vm._v(" "),_vm._l((_vm.sslxList),function(item,index){return _c('van-tab',{key:index,attrs:{"title":item.SSLXMC}})})],2):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"15px"}},_vm._l((_vm.resultXmList),function(item,index){return _c('van-collapse',{key:index,model:{value:(_vm.activeNames),callback:function ($$v) {_vm.activeNames=$$v},expression:"activeNames"}},[_c('van-collapse-item',{attrs:{"name":item.XMJC},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('div',{staticStyle:{"float":"left"}},[_vm._v("\n            "+_vm._s(item.XMJC)+"\n            "),(_vm.isLd !== '1' || _vm.reportLx === 'LDBM')?_c('van-tag',{attrs:{"type":item.ISBM === '1' ? 'success' : 'danger'}},[_vm._v(_vm._s(item.ISBM === "1" ? "已报名" : "未报名"))]):_vm._e()],1),_vm._v(" "),(
              item.DATALIST.length > 0 ? item.DATALIST[0].ISSF === '1' : false
            )?_c('div',{staticStyle:{"float":"right"}}):_vm._e()]},proxy:true}],null,true)},[_vm._v(" "),_vm._l((item.DATALIST),function(mxItem,mxIndex){return _c('van-cell',{key:mxIndex,attrs:{"value":_vm.ISBMRCOUNT !== '1'
              ? ''
              : mxItem.SSLX.substr(1, 2) === 'T' && _vm.reportLx === 'DYBM'
              ? ''
              : _vm.bmLx === 'TEAM'
              ? '已报' +
                mxItem.YBMRS +
                ' ' +
                (mxItem.SSLX.substr(1, 2) === 'D'
                  ? '对'
                  : mxItem.SSLX.substr(1, 2) === 'T'
                  ? '队'
                  : '人') +
                ' / ' +
                (mxItem.BMRSXZ.length === 0 ||
                mxItem.BMRSXZ === -1 ||
                mxItem.BMRSXZ > 999
                  ? '无限制'
                  : '剩余' +
                    (mxItem.BMRSXZ - mxItem.YBMRS) +
                    (mxItem.SSLX.substr(1, 2) === 'D'
                      ? '对'
                      : mxItem.SSLX.substr(1, 2) === 'T'
                      ? '队'
                      : '人'))
              : mxItem.YBMRS +
                ' ' +
                (mxItem.SSLX.substr(1, 2) === 'D'
                  ? '对'
                  : mxItem.SSLX.substr(1, 2) === 'T'
                  ? '队'
                  : '人') +
                ' / ' +
                (mxItem.BMRSXZ.length === 0 ||
                mxItem.BMRSXZ === -1 ||
                mxItem.BMRSXZ > 999
                  ? '无限制'
                  : '限' +
                    mxItem.BMRSXZ +
                    (mxItem.SSLX.substr(1, 2) === 'D'
                      ? '对'
                      : mxItem.SSLX.substr(1, 2) === 'T'
                      ? '队'
                      : '人')),"is-link":""},on:{"click":function($event){return _vm.navRmbmUrl(mxItem, mxItem.ITEMISBM)}},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('span',{staticClass:"custom-title"},[(
                  _vm.ssid !==
                    '69736c3638616f7575746b79664f736b334f425763314a66314841587771497a'
                )?_c('span',[_vm._v("\n                "+_vm._s(mxItem.SSLX === "MS" ||
                  mxItem.SSLX === "WS" ||
                  mxItem.SSLX === "XS"
                    ? mxItem.ISXB === "Y"
                      ? mxItem.SSLXMC
                      : "单打"
                    : mxItem.SSLX === "MD" ||
                      mxItem.SSLX === "WD" ||
                      mxItem.SSLX === "XD" ||
                      mxItem.SSLX === "SD"
                    ? mxItem.ISXB === "Y"
                      ? mxItem.SSLXMC
                      : "双打"
                    : mxItem.SSLXMC)+"\n              ")]):_vm._e(),_vm._v(" "),(
                  _vm.ssid ===
                    '69736c3638616f7575746b79664f736b334f425763314a66314841587771497a'
                )?_c('span',[_vm._v("\n                "+_vm._s(mxItem.SSLX.substr(0, 1) === "M" ? "男子" : "女子")+"\n              ")]):_vm._e()]),_vm._v(" "),(_vm.isLd !== '1' || _vm.reportLx === 'LDBM')?_c('van-tag',{attrs:{"type":mxItem.ITEMISBM === '1' ? 'success' : 'danger'}},[_vm._v(_vm._s(mxItem.ITEMISBM === "1" ? "已报名" : "未报名"))]):_vm._e(),_vm._v(" "),(mxItem.ISSF === '1' && mxItem.SSLX.substr(1, 2) !== 'T')?_c('van-tag',{attrs:{"type":"success"}},[_vm._v(_vm._s(mxItem.SFJE - 0 > 0 ? mxItem.SFJE + "元" : "多标准"))]):_vm._e(),_vm._v(" "),(
                mxItem.ISHYMF === '1' &&
                  mxItem.SSLX.substr(1, 2) !== 'T' &&
                  _vm.reportLx !== 'DYBM'
              )?_c('van-tag',{attrs:{"type":"warning"}},[_vm._v("\n              会员优惠\n            ")]):_vm._e()]},proxy:true}],null,true)})})],2)],1)}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19604bbe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/commonCom/ChangeXm.vue
// module id = null
// module chunks = 